module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp2_8004.cdf15b5c.png";